export default "__VITE_ASSET__ikNI8gQE__"